'use strict';

/**
 * @classname JobDetail
 * @classdesc 求人詳細
 */
export default class JobDetail {
	/**
	 * @constructor
	 * @param {jQuery} $e - body.job-detail
	 * @param {instance} controller - controllerオブジェクト
	 */
	constructor($e, controller) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._controller = controller;

		// 最近見た求人の設定
		this.setCurrentViewedJob();

	};


	/**
	 * 最近見た求人の設定
	 *
	 * @memberof JobDetail
	 * @return undefined
	 */
	 setCurrentViewedJob() {
		if($('html').hasClass('preview')) return;
		console.log(`${this.constructor.name}.setCurrentViewedJob`);

		const jobId = $('.section--job-detail.main .text--job-no').text();
		let jobPhotoUrl = $('.section--job-detail.main .card--job.detail .image--main-photo').eq(0).attr('src');
		const jobName = $('.section--job-detail.main .block--section-title .heading--section-title').text();
		const jobLocation = $('.section--job-detail.main .text--location').text();
		const jobPeriod =  $('.section--job-detail.main .text--period').text();
		const jobOccupation =  $('.section--job-detail.main .text--occupation').text();
		const jobSalary =  $('.section--job-detail.main .text--salary').text();
		const jobType =  $('.section--job-detail.main .text--jobType').text();

		console.log('jobPhotoUrl::' + jobPhotoUrl)
		
		if (jobPhotoUrl === undefined) {
			jobPhotoUrl = '/img/alpha-resort.webp'
		}
		
		const job = {
			id: jobId,
			photoUrl: jobPhotoUrl,
			title: jobName,
			location: jobLocation,
			period: jobPeriod,
			occupation: jobOccupation,
			salary: jobSalary,
			jobType: jobType
		}
		let jobs = localStorage.getItem('viewed_jobs') || [];
		if(jobs.length === 0){
			jobs.push(job);
		} else {
			jobs = JSON.parse(jobs);
			let tmp = [];
			tmp.push(job);
			for(let i = 0; i < jobs.length; i ++){
				const id = jobs[i].id;
				if(id !== jobId) {
					tmp.push(jobs[i]);
				}

			}
			// 10求人まで保存
			tmp = tmp.slice(0, 10);
			jobs = tmp;
		}
		jobs = JSON.stringify(jobs);
		console.log(`${this.constructor.name}.setCurrentViewedJob:jobs::` + jobs);
		localStorage.setItem('viewed_jobs', jobs);
	};

};
